var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-top d-flex align-items-center justify-content-center mb-0",attrs:{"id":"public-page"}},[_c('b-card',{staticStyle:{"max-width":"30rem"},attrs:{"id":"public-form","img-src":"/static/logo-black.png","img-top":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }